import React, { PureComponent } from 'react';
// import { Checkbox } from 'components';
import { Checkbox } from 'material-ui';
import { Tooltip } from '..';
import intl from 'react-intl-universal';

export default class PdfScaler extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      scale: true,
      keepAspect: true
    };
  }
  toggleCheckbox = (e) => {
    console.log(e);
  }
  handleChange = name => event => this.setState({ [name]: event.target.checked });

  componentDidUpdate() {
    const {onOptionChange} = this.props;

    onOptionChange({scale: this.state});
  }

  render() {
    return (
      <div className="">
        <label>
          <Checkbox
              checked={this.state.scale}
              onChange={this.handleChange('scale')}
              value="scale"
              clearable="false"
            /> &nbsp; {intl.get("Scale to fit page")} <Tooltip hint={intl.get("Selecting this option fit your PDF to new page size. Recommended.")} />
        </label>
        <br />
        <label>
          <Checkbox
              checked={this.state.keepAspect}
              onChange={this.handleChange('keepAspect')}
              value="keepAspect"
              clearable="false"
            /> &nbsp; {intl.get("Keep aspect ratio (proportions) intact")} <Tooltip hint={intl.get("Scale your PDF to fit new page size while keeping aspect ratio. Recommended.")} />
        </label>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PdfScaler/index.jsx